import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Paragraph as ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { getPeriodPerformance } from '../utils';
var Paragraph = styled(ParagraphSmall).withConfig({
  displayName: "Description__Paragraph",
  componentId: "sc-rkqr99-0"
})(["max-width:100%;"]);
var FixDecimal = function FixDecimal(val) {
  return val.toLocaleString('es-ES', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });
};
var MathRounder = function MathRounder(val) {
  return FixDecimal(Math.round(val * 100) / 100);
};
var Description = function Description(_ref) {
  var product = _ref.product,
    fundClass = _ref.fundClass,
    category = _ref.category;
  var performance = {
    M12: getPeriodPerformance(product.stats, 'M12', 'accumulated'),
    M36: getPeriodPerformance(product.stats, 'M36', 'accumulated')
  };
  return React.createElement(Fragment, null, React.createElement(Paragraph, null, "El fondo de inversi\xF3n ", product.name ? product.name : '', ' ', product.managementCompany ? "de la gestora ".concat(product.managementCompany.name) : '', " con ISIN ", product.isin, ' ', "tiene una rentabilidad en el \xFAltimo a\xF1o del", ' ', product.stats ? product.stats.performance.periods.find(function (item) {
    return item.period === 'M12';
  }) ? MathRounder(product.stats.performance.periods.find(function (item) {
    return item.period === 'M12';
  }).value) : 0 : 0, "%.", performance.M36 || performance.M12 ? React.createElement(Fragment, null, performance.M36 ? " A tres a\xF1os, su rentabilidad se sit\xFAa en el ".concat(MathRounder(performance.M36.value), "% ") : '', category ? performance.M36 && category.stats.performance.find(function (item) {
    return item.period === 'M36';
  }) !== null ? " frente a la media del ".concat(MathRounder(category.stats.performance.find(function (item) {
    return item.period === 'M36';
  }).value), "% de su categor\xEDa") : '' : '', ' ', performance.M12 ? " y a un a\xF1o, del ".concat(MathRounder(performance.M12.value), "%") : '', category ? performance.M12 && category.stats.performance.find(function (item) {
    return item.period === 'M12';
  }) !== null ? " respecto al ".concat(MathRounder(category.stats.performance.find(function (item) {
    return item.period === 'M12';
  }).value), "% de su categor\xEDa.") : '' : '') : null), React.createElement(Paragraph, null, "Su comisi\xF3n de gesti\xF3n es del ", fundClass.fees.mgr ? FixDecimal(fundClass.fees.mgr.value) || 0 : 0, "%, mientras que su comisi\xF3n de custodia se sit\xFAa en el ", fundClass.fees.cus ? FixDecimal(fundClass.fees.cus.value) || 0 : 0, "%. El ratio total de gastos del fondo se eleva al", ' ', fundClass.fees.ter ? FixDecimal(fundClass.fees.ter.value) || 0 : 0, "%."));
};
export { Description };